import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface GetClassStudentCountResponse {
  count: number;
}

export const getClassStudentCountAPI = async (classId: string) => {
  const response = await baseAPI.get<GetClassStudentCountResponse>(
    `students/count/enrollment/${classId}`,
  );
  return response.data;
};

export const getClassStudentCountQueryOptions = (
  classId: string,
  enabled: boolean,
) =>
  queryOptions({
    queryKey: [KEYS.CLASSES, classId, KEYS.STUDENT_COUNT],
    queryFn: () => getClassStudentCountAPI(classId),
    enabled: enabled,
    staleTime: 0,
  });

export const useGetClassStudentCount = ({
  classId,
  enabled,
}: {
  classId: string;
  enabled: boolean;
}) => {
  return useQuery({
    ...getClassStudentCountQueryOptions(classId, enabled),
  });
};
